import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { BankStatement } from '../entities/bank-statement';
//import { EmployeeManager } from '../entities/employee-manager';

interface ExtraSearchFields {
    //employeeManager?: EmployeeManager
}

@Injectable()
export class BankStatementService extends BaseCrudService<BankStatement> {

    public uri = '/api/bankStatement/';
    private httpParams2 = new HttpParams();
    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance BankStatementService');
    }

    buildSentence(entity?: BankStatement, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
        if (entity || extraSearchFields) {
            let query = ''
            query = query.concat(
                entity && entity.documentNumber ?
                `documentNumber${QueryOperator.Contain}${entity.documentNumber}${QueryOperator.Split}`
                : QueryOperator.Empty
            );
            query = query.concat(
                entity && entity.month ?
                `month.id${QueryOperator.Equal}${entity.month.id}${QueryOperator.Split}`
                : QueryOperator.Empty
            );
            if (entity && entity.fiscalYear) {
                query = query.concat(
                    entity.fiscalYear.id ? 'fiscalYear.id' + QueryOperator.Equal
                        + entity.fiscalYear.id + QueryOperator.Split : QueryOperator.Empty
                );
            }
            if (entity && entity.executingUnit) {
                query = query.concat(
                    entity.executingUnit.id ? 'executingUnit.id'
                        + QueryOperator.Equal + entity.executingUnit.id
                        + QueryOperator.Split : QueryOperator.Empty
                );
            }
            if (entity && entity.bankAccount) {
                query = query.concat(entity.bankAccount.id ? 'bankAccount.id'
                    + QueryOperator.Equal + entity.bankAccount.id
                    + QueryOperator.Split : QueryOperator.Empty
                );
            }
            /*if (entity && entity.district) {
                query = query.concat(
                    entity.district.id ? 'district.id'
                        + QueryOperator.Equal + entity.district.id
                        + QueryOperator.Split : QueryOperator.Empty
                );
            }

            if (extraSearchFields) {
                query = query.concat(
                    extraSearchFields.employeeManager && extraSearchFields.employeeManager.employee ?
                    `employee.id${QueryOperator.Equal}${extraSearchFields.employeeManager.employee.id}${QueryOperator.Split}`
                    : QueryOperator.Empty
                );
            }
*/
            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }

    validateImportBankStatement(bankStatement: BankStatement[]) {
        const url = `${this.rutaServidor}${this.uri}importBankStatement/`;
        this.spinnerService.showAll();
        this.httpParams2 = this.httpParams2.set(QueryOperator.Action, 'validate');
        return this.httpClient.post<BankStatement[]>(url, bankStatement, { params: this.httpParams2 })
          .pipe(
            tap(response => {
              this.spinnerService.hideAll();
            })
          );
      }
      
      createImportBankStatement(bankStatement: BankStatement[]) {
        const url = `${this.rutaServidor}${this.uri}importBankStatement/`;
        this.spinnerService.showAll();
        this.httpParams2 = this.httpParams2.set(QueryOperator.Action, 'create');
        return this.httpClient.post<BankStatement[]>(url, bankStatement, { params: this.httpParams2 })
          .pipe(
            tap(response => {
              this.spinnerService.hideAll();
            })
          );
      }


    /*
    searchByEmployeeOfEmployeeManager(event?: LazyLoadEvent,
                                extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<CostCenter>> {

        const url = `${this.rutaServidor}${this.uri}search`;
        let httpParams = this.buildSentence(undefined, undefined, extraSearchFields);
        httpParams = this.httpParams.set(QueryOperator.SearchName, 'searchByEmployeeOfEmployeeManager');
        this.spinnerService.showAll();
        return this.httpClient.get<ResponsePageable<CostCenter>>(url, { params: httpParams })
            .pipe(
                tap(response => {
                   //console.log('searchByEmployeeManager');
                    if (response.numberOfElements > 0) {
                       //console.log(response);
                        response.content.forEach((value) => {
                            // debugger;
                            this.addLogicToSearch(value);
                            this.convertToDate(value);
                        })
                    }
                   //console.log(response);
                    this.spinnerService.hideAll();
                    return response;
                })
            );
    }
    */
}



// WEBPACK FOOTER //
// ./src/app/core/services/bank-statement.service.ts